(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1192],{

/***/ 73600:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacts",
      function () {
        return __webpack_require__(7611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contacts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@prismic/context.tsx
var context = __webpack_require__(47233);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/Container.tsx
var Container = __webpack_require__(40080);
;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsAddress/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 120px 0 106px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 110px 0 101px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    padding: 70px 0 70px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 210px 0 235px;\n  display: flex;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 84px;\n    flex-basis: 47%;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 15px;\n    flex-basis: 43%;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-basis: 100%;\n    padding-left: 0;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 164px;\n  flex-basis: 52%;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 110%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 35px 0 35px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 150px;\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 21px;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      mmargin-bottom: 12px;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-bottom: 0;\n      "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h4 {\n    margin-bottom: 30px;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 110%;\n    color: rgba(43, 43, 43, 0.3);\n    ",
        "\n    ",
        "\n  }\n  ul {\n    li {\n      margin-bottom: 3px;\n      font-size: ",
        ";\n      line-height: 160%;\n      color: rgba(44, 44, 44, 0.8);\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var Title = globalStyles/* styled.div */.zo.div(_templateObject7(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject6()));
var H3 = globalStyles/* styled.h3 */.zo.h3(_templateObject8(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h5FontSize;
});
var Address = globalStyles/* styled.div */.zo.div(_templateObject10(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject9()));
var Details = globalStyles/* styled.div */.zo.div(_templateObject11());
var Item = globalStyles/* styled.div */.zo.div(_templateObject15(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h5FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject12()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject13()), function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject14()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsAddress/ContactsAddress.tsx




var ContactsAddress = function(param) {
    var contacts = param.contacts;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H3, {
                    children: contacts === null || contacts === void 0 ? void 0 : contacts.address_title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: contacts === null || contacts === void 0 ? void 0 : contacts.address
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: contacts === null || contacts === void 0 ? void 0 : contacts.registration_details
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsAddress/index.ts


;// CONCATENATED MODULE: ./src/images/marker.svg
var marker_namespaceObject = __webpack_require__.p + "static/images/marker.svg";
;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsTop/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 70px 0 78px;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 60px 0 60px;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 122px 0 125px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 45px;\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 15px;\n    letter-spacing: -0.5px;\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 17px;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 41px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 11px;\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 35px;\n  max-width: 522px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: normal;\n  text-align: center;\n  line-height: 160%;\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var styles_Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(styles_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject1()));
var Icon = globalStyles/* styled.img */.zo.img(styles_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject3()));
var styles_Title = globalStyles/* styled.h1 */.zo.h1(styles_templateObject7(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h1FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject6()));
var SubTitle = globalStyles/* styled.h6 */.zo.h6(styles_templateObject9(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject8()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsTop/ContactsTop.tsx




var ContactsTop = function(param) {
    var contacts = param.contacts;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                src: marker_namespaceObject,
                alt: "contacts icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                children: contacts === null || contacts === void 0 ? void 0 : contacts.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                children: contacts === null || contacts === void 0 ? void 0 : contacts.description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsTop/index.ts


// EXTERNAL MODULE: ./src/@next/components/organisms/ContactsForm/index.ts + 2 modules
var ContactsForm = __webpack_require__(64561);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
;// CONCATENATED MODULE: ./src/images/contact-widget/email-widget.svg
var email_widget_namespaceObject = __webpack_require__.p + "static/images/email-widget.svg";
;// CONCATENATED MODULE: ./src/images/contact-widget/help-widget.svg
var help_widget_namespaceObject = __webpack_require__.p + "static/images/help-widget.svg";
;// CONCATENATED MODULE: ./src/images/contact-widget/messenger-widget.svg
var messenger_widget_namespaceObject = __webpack_require__.p + "static/images/messenger-widget.svg";
;// CONCATENATED MODULE: ./src/images/contact-widget/phone-widget.svg
var phone_widget_namespaceObject = __webpack_require__.p + "static/images/phone-widget.svg";
// EXTERNAL MODULE: ./src/images/contact-widget/whatsapp-widget.svg
var whatsapp_widget = __webpack_require__(76380);
;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsList/styles.ts

function ContactsList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n  "
    ]);
    ContactsList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactsList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  display: ",
        ";\n  margin-bottom: 40px;\n  &:last-child {\n    margin-bottom: 0 !important;\n  }\n  ",
        "\n"
    ]);
    ContactsList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactsList_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50px;\n    height: 50px;\n    flex: 0 0 50px;\n  "
    ]);
    ContactsList_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactsList_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 40px;\n    height: 40px;\n    flex: 0 0 40px;\n    margin-right: 10px;\n  "
    ]);
    ContactsList_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContactsList_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 20px;\n      max-height: 20px;\n      width: auto;\n      height: auto;\n    "
    ]);
    ContactsList_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ContactsList_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  flex: 0 0 68px;\n  width: 68px;\n  height: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  margin-right: 20px;\n  background-color: ",
        ";\n  ",
        "\n  ",
        "\n  img {\n    display: block;\n    ",
        "\n  }\n"
    ]);
    ContactsList_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ContactsList_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  line-height: 1.5em;\n  fon-familyt: ",
        ";\n  font-size: ",
        ";\n  white-space: nowrap;\n  text-transform: capitalize;\n"
    ]);
    ContactsList_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ContactsList_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: none;\n  font-size: ",
        ";\n  opacity: 0.8;\n  margin-top: 5px;\n"
    ]);
    ContactsList_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var handleIconType = function(icon) {
    switch(icon){
        case "messenger":
            return "#2f80ed";
        case "whatsapp":
            return "#40c351";
        case "help":
            return "#4f6e7c";
        default:
            return "#ca9c66";
    }
};
var LinkWrapper = globalStyles/* styled.a */.zo.a(ContactsList_styles_templateObject1(), function(param) {
    var icon = param.icon;
    return !(icon === "help") ? "flex" : "none";
}, globalStyles/* media.largeScreen */.BC.largeScreen(ContactsList_styles_templateObject()));
var IconWrapper = globalStyles/* styled.div */.zo.div(ContactsList_styles_templateObject5(), function(param) {
    var icon = param.icon;
    return handleIconType(icon);
}, globalStyles/* media.largeScreen */.BC.largeScreen(ContactsList_styles_templateObject2()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ContactsList_styles_templateObject3()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ContactsList_styles_templateObject4()));
var Text = globalStyles/* styled.div */.zo.div(ContactsList_styles_templateObject6(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
});
var Hint = globalStyles/* styled.div */.zo.div(ContactsList_styles_templateObject7(), function(props) {
    return props.theme.typography.smallFontSize;
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsList/ContactsList.tsx









var ContactsList = function(param) {
    var layout = param.layout;
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: layout === null || layout === void 0 ? void 0 : (ref = layout.contact) === null || ref === void 0 ? void 0 : ref.map(function(c, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper, {
                href: (0,prismic_config/* linkResolver */.kG)(c.link),
                icon: c.type,
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                        icon: c.type,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                c.type === "phone" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: phone_widget_namespaceObject,
                                    alt: "phone"
                                }),
                                c.type === "help" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: help_widget_namespaceObject,
                                    alt: "help"
                                }),
                                c.type === "email" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: email_widget_namespaceObject,
                                    alt: "email"
                                }),
                                c.type === "messenger" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: messenger_widget_namespaceObject,
                                    alt: "messenger"
                                }),
                                c.type === "whatsapp" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: whatsapp_widget,
                                    alt: "whatsapp"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: c.type === "phone" || c.type === "email" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                c.type,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hint, {
                                    children: c.label
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: c.label
                        })
                    })
                ]
            });
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/ContactsList/index.ts


;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsLinks/styles.ts

function ContactsLinks_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 84px;\n  "
    ]);
    ContactsLinks_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactsLinks_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 0;\n    padding-bottom: 40px;\n  "
    ]);
    ContactsLinks_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactsLinks_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding-bottom: 20px;\n    margin-left: 22px;\n  "
    ]);
    ContactsLinks_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactsLinks_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  padding-left: 164px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ContactsLinks_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContactsLinks_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 41px;\n    line-height: 130%;\n  "
    ]);
    ContactsLinks_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ContactsLinks_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n  "
    ]);
    ContactsLinks_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ContactsLinks_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 34px;\n  "
    ]);
    ContactsLinks_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ContactsLinks_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 62px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 110%;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ContactsLinks_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var ContactsLinks_styles_Wrapper = globalStyles/* styled.div */.zo.div(ContactsLinks_styles_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(ContactsLinks_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ContactsLinks_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(ContactsLinks_styles_templateObject2()));
var ContactsLinks_styles_Title = globalStyles/* styled.h3 */.zo.h3(ContactsLinks_styles_templateObject7(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h3FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(ContactsLinks_styles_templateObject4()), globalStyles/* media.mediumScreen */.BC.mediumScreen(ContactsLinks_styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(ContactsLinks_styles_templateObject6()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsLinks/ContactsLinks.tsx




var ContactsLinks = function(param) {
    var contacts = param.contacts, layout = param.layout;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ContactsLinks_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsLinks_styles_Title, {
                children: contacts === null || contacts === void 0 ? void 0 : contacts.contacts_title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsList, {
                layout: layout
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsLinks/index.ts


// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/@sdk/gqlTypes/generatedHooks.tsx + 1 modules
var generatedHooks = __webpack_require__(73134);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var templates_Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/images/contacts/contacts-bg.png
/* harmony default export */ var contacts_bg = ({"src":"/_next/static/media/contacts-bg.2401536b.png","height":575,"width":950,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAMFBMVEVMaXHo5+hreGLj4+PY2NjU1NTX19esnoI/UTX////atqqGk33p6elvemhNYzvU09Rh3hu3AAAAD3RSTlMA+sHo/LZnJdojFWgj11Iyz6QZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJUlEQVR4nGNg52KAACY+KIODm5MHIsLIyMwGYvDyszCyMjAwAAAKuwB9+kkS7QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/views/Contacts/styles.ts

function Contacts_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 81px 0 80px;\n  "
    ]);
    Contacts_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-size: contain;\n  "
    ]);
    Contacts_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 60px 0 60px;\n  "
    ]);
    Contacts_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 151px 0 127px;\n  background-color: #f1f1f0;\n  background-image: url(",
        ");\n  background-position: left bottom;\n  background-repeat: no-repeat;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Contacts_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    align-items: center;\n  "
    ]);
    Contacts_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "\n"
    ]);
    Contacts_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 152px;\n  "
    ]);
    Contacts_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-left: none;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    padding-left: 0;\n    padding-top: 70px;\n  "
    ]);
    Contacts_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 50px;\n    width: 100%;\n  "
    ]);
    Contacts_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Contacts_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  padding-left: 203px;\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Contacts_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 130%;\n  "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n    text-align: center;\n  "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-bottom: 50px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 110%;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n  "
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n  "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 75px 35px;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 70px 10px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 75px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #e7e7e6;\n  border-radius: 4px;\n\n  ",
        "\n  ",
        "\n\n  & > p {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    text-align: center;\n    line-height: 160%;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}



var Background = globalStyles/* styled.div */.zo.div(Contacts_styles_templateObject3(), contacts_bg.src, globalStyles/* media.largeScreen */.BC.largeScreen(Contacts_styles_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(Contacts_styles_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(Contacts_styles_templateObject2()));
var Content = (0,globalStyles/* styled */.zo)(templates_Container/* Container */.W2)(Contacts_styles_templateObject5(), globalStyles/* media.mediumScreen */.BC.mediumScreen(Contacts_styles_templateObject4()));
var Form = globalStyles/* styled.div */.zo.div(Contacts_styles_templateObject9(), globalStyles/* media.largeScreen */.BC.largeScreen(Contacts_styles_templateObject6()), globalStyles/* media.mediumScreen */.BC.mediumScreen(Contacts_styles_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(Contacts_styles_templateObject8()));
var Contacts_styles_Title = globalStyles/* styled.h3 */.zo.h3(styles_templateObject13(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h3FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject10()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject11()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject12()));
var Loader = globalStyles/* styled.div */.zo.div(_templateObject16(), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject14()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject15()));
var SuccessMessage = globalStyles/* styled.div */.zo.div(_templateObject19(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject17()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject18()), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
});

;// CONCATENATED MODULE: ./src/views/Contacts/Page.tsx










var Page = function(param) {
    var contacts = param.contacts, layout = param.layout;
    var intl = (0,useIntl/* default */.Z)();
    // TODO: Fix the mutation
    var ref = (0,_sliced_to_array/* default */.Z)((0,generatedHooks/* useSendContactUsMutation */.iL)({}), 2), sendContactUsMutation = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading;
    if (data && data.sendContactUs.errors.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessMessage, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: intl.formatMessage({
                        defaultMessage: "Thank you!",
                        id: "aYIUar"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: intl.formatMessage({
                        defaultMessage: "Your message has been successfully sent.",
                        id: "emIUms"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "contacts-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsTop, {
                contacts: contacts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsLinks, {
                            contacts: contacts,
                            layout: layout
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Contacts_styles_Title, {
                                    children: contacts === null || contacts === void 0 ? void 0 : contacts.form_title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsForm/* ContactsForm */.H, {
                                    defaultValues: {
                                        customerEmail: "",
                                        message: "",
                                        subject: ""
                                    },
                                    handleSubmit: function(values) {
                                        return sendContactUsMutation({
                                            variables: {
                                                email: values.customerEmail,
                                                message: values.message,
                                                subject: values.subject
                                            }
                                        });
                                    },
                                    errorsFromBackend: data === null || data === void 0 ? void 0 : data.sendContactUs.errors
                                }),
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {
                                    children: intl.formatMessage({
                                        defaultMessage: "Loading....",
                                        id: "YixU0V"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsAddress, {
                contacts: contacts
            })
        ]
    });
};
Page.displayName = "ContactsPage";
/* harmony default export */ var Contacts_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Contacts/View.tsx






var View = function(param) {
    var contacts = param.contacts, seo = param.seo;
    var layout = (0,context/* usePrismicLayout */.E)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Contacts_Page, {
                contacts: contacts,
                layout: layout
            })
        ]
    });
};
View.displayName = "ContactsView";
/* harmony default export */ var Contacts_View = (View);

;// CONCATENATED MODULE: ./src/views/Contacts/index.tsx


;// CONCATENATED MODULE: ./src/pages/contacts/index.ts

var __N_SSG = true;
/* harmony default export */ var contacts = (Contacts_View);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,4561,9774,2888,179], function() { return __webpack_exec__(73600); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);